abstract class AbstractInterceptor {
  abstract intercept(): XMLHttpRequest
  abstract unIntercept(): void
}

export default AbstractInterceptor
